import { c as _c } from "react/compiler-runtime";
import MuiTooltip, { TooltipProps as MUITooltipProps } from '@mui/material/Tooltip';
import type { ElementType } from 'react';
import { styled } from '../styles';
import Typography from '../Typography';
export interface Props extends Omit<MUITooltipProps, 'title'> {
  title?: string;
  content?: string;
  placement?: 'bottom-start' | 'bottom-end';
  describeChild?: boolean;
}
const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column'
});
const MuiTooltipWithDescribeChild = MuiTooltip as unknown as ElementType<MUITooltipProps & {
  describeChild?: boolean;
}>;
const Tooltip = t0 => {
  const $ = _c(13);
  const {
    children,
    title: t1,
    content: t2,
    placement: t3,
    describeChild: t4,
    disableTouchListener: t5,
    onClose,
    onOpen,
    open
  } = t0;
  const title = t1 === undefined ? "" : t1;
  const content = t2 === undefined ? "" : t2;
  const placement = t3 === undefined ? "bottom-start" : t3;
  const describeChild = t4 === undefined ? false : t4;
  const disableTouchListener = t5 === undefined ? false : t5;
  const shouldShowTooltip = Boolean(title) || Boolean(content);
  let t6;
  if ($[0] !== content || $[1] !== shouldShowTooltip || $[2] !== title) {
    t6 = shouldShowTooltip ? <Container sx={{
      padding: title && content ? 2 : 1
    }}>{title && <Typography variant="subheadingSmall" color="inherit">{title}</Typography>}{content && <Typography variant="caption" dangerouslySetInnerHTML={{
        __html: content
      }} color="inherit" sx={{
        "& *": {
          color: "inherit",
          fontSize: "inherit",
          lineHeight: "inherit"
        },
        "& ul": {
          margin: 0,
          paddingLeft: 2
        },
        ...(title && {
          paddingTop: 1
        })
      }} />}</Container> : "";
    $[0] = content;
    $[1] = shouldShowTooltip;
    $[2] = title;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== children || $[5] !== describeChild || $[6] !== disableTouchListener || $[7] !== onClose || $[8] !== onOpen || $[9] !== open || $[10] !== placement || $[11] !== t6) {
    t7 = <MuiTooltipWithDescribeChild enterTouchDelay={0} leaveTouchDelay={700} title={t6} placement={placement} arrow={true} describeChild={describeChild} disableTouchListener={disableTouchListener} onClose={onClose} onOpen={onOpen} open={open}>{children}</MuiTooltipWithDescribeChild>;
    $[4] = children;
    $[5] = describeChild;
    $[6] = disableTouchListener;
    $[7] = onClose;
    $[8] = onOpen;
    $[9] = open;
    $[10] = placement;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export default Tooltip;